import {HttpClient} from '@angular/common/http';
import {Injectable} from '@angular/core';
import {BaseApiTemplateService} from '../shared/base-api-template-service.model';
import {Core2Config} from '../shared/core2Config';
import {AppCfgMainContainerModel} from '../../../../../models/aggregates/app-cfg-main';

@Injectable({providedIn: 'root'})
export class TenantMessageTemplateService extends BaseApiTemplateService<AppCfgMainContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + 'app/message-templates';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + 'app/message-templates';
    this.httpClient = http;
  }

}
